import React from 'react';
import { useSelector } from 'react-redux';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import scheduleDatasource from '@gameday/core/datasources/schedule';
import ErrorBoundaryWrapper from '../../ErrorFallback/ErrorBoundaryWrapper';
import TapStory from '../TapStory';
import { getTapStoryState } from '../store/selectors/tapStorySelector';
import updateTapStory from '../store/reducers/tapStoryReducer';
import tapStoryDataRequestAction from '../store/actions/tapStoryDataAction';

initContainerData.register({
    datasources: {
        schedule: scheduleDatasource
    },
    reducers: {
        tapStory: updateTapStory
    }
});

const fetchData = () => {
    return tapStoryDataRequestAction();
};

const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const TapStoryContainer = () => {
    const tapStory = useSelector(getTapStoryState);

    return (
        <ErrorBoundaryWrapper componentName='Tap Story'>
            <TapStory {...tapStory}/>
        </ErrorBoundaryWrapper>
    );
};

export default TapStoryContainer;
export { fetchData, routes };
